import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

// const onCodeFocus = (event) => {
//   event.target.select();
// };

export default class Integration extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    // const clientName = this.props.softwares.info.STUDIO_NAME;
    // const clientId = this.props.softwares.studioId;

    // const isBookingSwSetup = this.props.softwares.status === 'verify_success';

    // const code = `<!-- Start TrueLark Chat --><script src="https://truelark.com/chat-widget/js/config.js"></script><script src="https://truelark.com/chat-widget/js/loader.js"></script><script>fdchat({ clientId: '${clientId}', clientName: '${clientName}' });</script><!-- End TrueLark Chat -->`;

    return (
      <div className="integration">
        <div className="card">
          <div className="card__header">
            <span className="card__header__text">Chat Widget Integration</span>
          </div>
          <div className="card__content">
            <div className="integration__overview">
              <p className="integration__overview__instructions">
                {/* Add contact us message here */}
                Contact{' '}
                <a href="mailto:support@truelark.com">
                  support@truelark.com
                </a>{' '}
                for widget integration with your website
              </p>
              {/*
                <p className="integration__overview__instructions">
                  To integrate our chat widget on your website, just
                  paste the following code into the page you want the chat widget to be available.
                  This code can either be placed inside the &lt;head&gt; and &lt;/head&gt; tags,
                  or just before the &lt;/body&gt; tag.
                </p>
                */}
              {/*
                isBookingSwSetup && clientId ?
                  <textarea onClick={onCodeFocus} readOnly value={code} /> :
                  <p className="message message--error">
                    Please complete Booking Software setup to enable chat widget integration
                  </p>
                */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Integration.defaultProps = {};

Integration.propTypes = {
  softwares: PropTypes.shape({
    status: PropTypes.string,
    selectedSoftware: PropTypes.string,
    studioId: PropTypes.string,
    bookerClientId: PropTypes.string,
    info: PropTypes.shape({
      STUDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
};
